import includes from 'lodash/includes';
import isEqual from 'lodash/isEqual';
import { ProjectSynthesisJobType } from '@Pages/RetroSynthesis/constants';

// Generate props for PlanPredictedItem, PlanPublishedItem
export const getSelectionPropsForCheckbox = ({
  selectedItems = [],
  setSelectedItems = () => {},
  customContainsFunc = (items, item) => includes(items, item),
} = {}) => {
  // eslint-disable-next-line no-shadow
  const isSelected = (selectedItems, index) => customContainsFunc(selectedItems, index);
  const onSelectionChange = ({ index, checked }) => {
    if (checked && !customContainsFunc(selectedItems, index)) {
      setSelectedItems([...selectedItems, index]);
    } else if (!checked) {
      setSelectedItems(selectedItems.filter((i) => !customContainsFunc([index], i)));
    }
  };
  return { isSelected, onSelectionChange };
};

// Helper function to check if items are equal based on tab type
const areItemsEqual = (item1, item2, isPredictedTab) => (isPredictedTab ? isEqual(item1, item2) : item1.id === item2.id);

// Helper function to get matching count between selected and current items
const getMatchingCount = (selectedItems, currentItems, isPredictedTab) => {
  if (!selectedItems || !currentItems) return 0;

  return selectedItems.filter((selectedItem) =>
    currentItems.some((currentItem) => areItemsEqual(selectedItem, currentItem, isPredictedTab))
  ).length;
};

// Helper function to deselect current page items
const deselectCurrentPageItems = (selectedItems, currentItems, isPredictedTab) =>
  selectedItems.filter((selectedItem) => !currentItems.some((currentItem) => areItemsEqual(selectedItem, currentItem, isPredictedTab)));

// Helper function to append current page items to selections
const appendCurrentPageItems = (selectedItems, currentItems, isPredictedTab) => {
  const newSelections = Array.isArray(selectedItems) ? [...selectedItems] : [];
  if (Array.isArray(currentItems)) {
    currentItems?.forEach((currentItem) => {
      if (!newSelections.some((selectedItem) => areItemsEqual(selectedItem, currentItem, isPredictedTab))) {
        newSelections.push(currentItem);
      }
    });
  }
  return newSelections;
};

// Generate props for SelectedItemsControls
export const getSelectionPropsForSelectAll = ({
  selectedItemsByTab = {},
  setSelectedItemsByTab = () => {},
  activeTab,
  activeTabData,
} = {}) => {
  const activeTabCount = activeTabData ? activeTabData.length : 0;
  const selectedItemsForActiveTab = selectedItemsByTab[activeTab] || [];
  const isPredictedTab = activeTab.toLowerCase() === ProjectSynthesisJobType.PREDICTED;

  const matchingCount = getMatchingCount(selectedItemsForActiveTab, activeTabData, isPredictedTab);
  const allItemsSelected = activeTabCount > 0 && matchingCount === activeTabCount;
  const currentSelectedItems = Object.values(selectedItemsByTab).reduce((memo, indexes) => (indexes ? memo + indexes.length : memo), 0);
  const someItemsSelected = matchingCount > 0 && matchingCount < activeTabCount;

  const checkAllItems = () => {
    if (allItemsSelected) {
      const remainingSelections = deselectCurrentPageItems(selectedItemsForActiveTab, activeTabData, isPredictedTab);
      return setSelectedItemsByTab(activeTab, remainingSelections);
    }

    const newSelections = appendCurrentPageItems(selectedItemsForActiveTab, activeTabData, isPredictedTab);
    return setSelectedItemsByTab(activeTab, newSelections);
  };

  return { allItemsSelected, currentSelectedItems, someItemsSelected, checkAllItems };
};
